import * as types from '../actions/actionTypes';
import initialState from './initialState';

        
        
export default function crucigramapalabrasReducer(state= initialState.crucigramapalabras, action){
    let newState;
	switch(action.type){
         case types.LOAD_CRUCIGRAMAPALABRAS_LIST_SUCCESS:		
            action.crucigramapalabras.filtroActivo=state.filtroActivo;
            action.crucigramapalabras.filtroActual=state.filtroActual;
            action.crucigramapalabras.showActivos=state.showActivos;
			 action.crucigramapalabras.paginaActual=action.crucigramapalabras.pageable.pageNumber;
			 action.crucigramapalabras.registrosPorPagina=action.crucigramapalabras.size;
            
            return action.crucigramapalabras;

        case types.BORRAR_CRUCIGRAMAPALABRAS_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(crucigramapalabras => crucigramapalabras.id !== action.crucigramapalabras.id)];          
			return newState;    
            
        case types.ACTIVAR_CRUCIGRAMAPALABRAS_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(crucigramapalabras => crucigramapalabras.id !== action.crucigramapalabras.id)];          
			 return newState;
            
        case types.SET_FILTRO_CRUCIGRAMAPALABRAS:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}